export default {
  patientAuth: {
    alert: {
      chat: {
        title: 'Nota',
        description:
          'Tu proveedor ha solicitado que respondas estas preguntas con nuestro Asistente de Atención Virtual, Lumi. Esto te dará la oportunidad de compartir detalles de tu historial médico que no están disponibles en tu registro médico.',
      },
      form: {
        title: 'Nota',
        description:
          'Tu proveedor ha solicitado que completes este formulario. Por favor verifica tu identidad para continuar.',
      },
    },
    dob: {
      label: 'Ingresa tu fecha de nacimiento para continuar',
      placeholder: 'MM/DD/AAAA',
      requiredError: 'Por favor ingresa tu fecha de nacimiento',
      formatError: 'Por favor ingresa una fecha válida en formato MM/DD/AAAA',
      validationError:
        'La fecha de nacimiento no coincide con nuestros registros.',
    },
    submit: 'Enviar',
    troubleLoggingIn: '¿Problemas para iniciar sesión?',
    emergencyGuideline:
      'Si tienes una emergencia médica, por favor interrumpe este proceso y llama al 911',
    languageToggle: 'In English?',
  },
  errors: {
    logoutFailed: 'Error al cerrar sesión. Por favor intenta de nuevo',
    userValidationFailed:
      'Error al validar usuario. Por favor intenta de nuevo',
    expiredLink: {
      title: '¡Ups!',
      description:
        'El enlace de la cita parece ser inválido o ha expirado. Por favor verifica el enlace en tu correo electrónico o contacta a tu equipo de atención para obtener ayuda.',
    },
  },
  logout: {
    title: 'Cerrar sesión',
    description:
      'Has cerrado sesión exitosamente. Ahora puedes cerrar esta ventana.',
  },
};
